<script>
  import { validInput, normalizeRowBody } from "../../javascripts/utils.js"
  import Marker from "./components/marker"
  import CaseSensitiveIcon from "./components/caseSensitive.icon.svelte"
  export let directoryTitle = "whole theme"
  export let fetchFiles = () => {}
  export let onSearchQuery = () => {}
  export let onReplaceQuery = () => {}
  let Range = ace.require("ace/range").Range
  let searchValue = null
  let newValue = null
  let include = ""
  let inclusionRule = false
  let results = null
  let files = null
  let isCaseSensitive = false

  const getSeacrhResults = () => onSearchQuery(searchValue, files, include, inclusionRule, isCaseSensitive)

  const handleSubmit = async () => {
    results = null
    if (!validInput(searchValue)) return false
    files = await fetchFiles()
    results = getSeacrhResults()
  }

  const handleReplaceAll = () => {
    if (!validInput(searchValue)) return false
    let results = getSeacrhResults()
    onReplaceQuery(results, searchValue, newValue)
    reset()
  }

  const onCodeSnippetClick = (e, secure_random, { line_number, raw_body }) => {
    CodeEditor.Tree.openFile(e, tree.getNodeByKey(secure_random), () => {
      let line = line_number - 1
      const { query } = results
      let queryIdx = raw_body.indexOf(query)
      let range = new Range(line, queryIdx, line, queryIdx + query.length)
      editor.scrollToLine(line_number, true)
      editor.session.selection.setSelectionRange(range)
    })
  }

  const reset = async () => {
    searchValue = null
    newValue = null
    include = ""
    inclusionRule = false
    results = null
  }

  const toggleShowCodeSnippet = (secure_random) => {
    results.items = results.items.map((i) => {
      if (i.secure_random === secure_random) i.hideCodeSnippet = !i.hideCodeSnippet
      return i
    })
  }
</script>

<style>
  .hideCodeSnippet {
    display: none !important;
  }
</style>

<form autocomplete="off" on:submit|preventDefault={handleSubmit}>
  <header>
    <h4>Search in {directoryTitle}...</h4>
  </header>

  <div class="form-item">
    <div class="flex">
      <input type="text" bind:value={searchValue} placeholder="Search" />
      <CaseSensitiveIcon isActive={isCaseSensitive} onClick={() => (isCaseSensitive = !isCaseSensitive)} />
    </div>
    <button type="submit" class="btn btn-primary">Find</button>
  </div>

  <div class="form-item">
    <input type="text" bind:value={newValue} placeholder="Replace with" />
    <button type="button" on:click={handleReplaceAll} class="btn btn-primary">Replace All</button>
  </div>

  <div class="extra-search form-item">
    <input type="text" bind:value={include} placeholder="Include path" id="include" />
    <div class="include">
      <label for="inclusionRule">Strict match</label>
      <input type="checkbox" bind:checked={inclusionRule} placeholder="Path" id="inclusionRule" />
    </div>
  </div>
</form>

{#if results && results.items}
  <ul class="ixcanul-ui" id="codeSearch-results">
    <div class="results-stats">
      <Marker>{results.matches.length}&nbsp;</Marker>
      <span>results were found for</span>
      <Marker>{results.query}</Marker>
      in
      <Marker>{results.relevantFiles.length}</Marker>
      <span>files</span>
      <p>
        <Marker>Note:</Marker>Tephra content will
        <Marker>not</Marker>
        be replaced with the replace function
      </p>
    </div>
    {#each results.items as { path, matchedLines, secure_random, hideCodeSnippet }}
      <li class="codeSearch-result-item" class:isTephra={/^tephra/.test(path)}>
        <span class="codeSearch-result-item-label">
          <i class="fa fa-file-text" aria-hidden="true" />
          <span>{path}
            -
            <Marker>{matchedLines.length} matches</Marker></span>
          <button class="codeSearch-result-item-fold" on:click={toggleShowCodeSnippet.bind(null, secure_random)}>{hideCodeSnippet ? '+' : '-'}</button>
        </span>

        {#each matchedLines as match}
          <code class:hideCodeSnippet on:click={(e) => onCodeSnippetClick(e, secure_random, match)}>
            {#each normalizeRowBody(match.raw_body, results.query) as item}
              {#if item.toLowerCase() === results.query.toLowerCase()}
                <Marker>{item}</Marker>
              {:else}{item}{/if}
            {/each}
          </code>
        {/each}
      </li>
    {/each}
  </ul>
{/if}
